import React from 'react';
import 'react-toastify/dist/ReactToastify.css';
import {useDispatch, useSelector} from 'react-redux';
import 'mapbox-gl/dist/mapbox-gl.css';
import CssBaseline from '@mui/material/CssBaseline';
import Notification from "@/common/Notification";
import Routes from '@/routes/Routes';
import Sidebar from '@/routes/Sidebar';
import {refreshTenantFeatures} from '@/shared/user/actions';
import '@/styles/styles.sass';
import {enabledFeatureRoutes} from "@/utils/utils";
import {useHistory} from "react-router-dom";
import { isTopNavEnabled} from "./shared/access";
import {resetRedirectHome} from "./shared/user/actions";

function AppLayout(props) {
    let {childProps} = props;
    const routes = (<Routes childProps={childProps}/>);
    const history = useHistory();
    const dispatch = useDispatch();
    const shouldRedirectHome = useSelector(state => state.logout.shouldRedirectHome);
    const topNavStyle = {};
    const aboutMe = useSelector(state => state.user.aboutMe);
    let masqWarning=false;

    React.useEffect(() => {
        const unlisten = history.listen((location, action) => {
            if (enabledFeatureRoutes.test(location.pathname)) {
                dispatch(refreshTenantFeatures());
            }
        });

        return () => {
            unlisten();
        };
    }, [history, dispatch]);

    React.useEffect(() => {
        if (shouldRedirectHome) {
            window.location.href = '/';
            dispatch(resetRedirectHome());
        }
    }, [shouldRedirectHome]);
    if (aboutMe.currentTenant && aboutMe.user.userType && aboutMe.user.userType === "INTERNAL_SUPPORT") {
        masqWarning = true;
    }
    // If they are not logged in just put in the routes with no sidebar. It will go to Auth flows.
    if (!childProps.isAuthenticated || childProps.needsVerification) {
        return (
            <div className="App logged-out">
                {routes}
            </div>
        );
    }
    if (isTopNavEnabled()) {
        topNavStyle.position = 'fixed';
        topNavStyle.marginTop = masqWarning ? '145px' : '100px';
    }
    let contentViewClass;
    if (!['video-chat', 'feedback-public', 'take-survey', 'ehr', 'applicant'].some(p => window.location.pathname.includes(p)))  {
        contentViewClass = !isTopNavEnabled()
            ? "contentView"
            : masqWarning
                ? "contentViewWithTopNavWithMasqWarning"
                : "contentViewWithTopNavWithoutMasqWarning";
    }else {
        contentViewClass = "contentView"
        if (Object.keys(topNavStyle).length !== 0) {
            delete topNavStyle.marginTop;
            delete topNavStyle.position;
        }
    }
    // Render full logged in view
    return (
        <div>
                {isTopNavEnabled() && <Sidebar {...childProps} />}
            <div className="appWindow" style={topNavStyle} data-testid="appContainer">
                {!isTopNavEnabled() && <Sidebar {...childProps} />}
                <main className={contentViewClass}>
                    <CssBaseline/>
                    <Notification/>
                    {routes}
                </main>
            </div>
        </div>
    );
}

export default AppLayout;